// Module
var code = "<template class=\"group-bar\"> <require from=\"./group-bar.scss\"></require> <require from=\"./group-pane\"></require> <group-pane class=\"root\" is-root.bind=\"true\"></group-pane> </template> ";
// Exports
export default code;